import { render, staticRenderFns } from "./NotificationsNone.vue?vue&type=template&id=6989d7a0&"
import script from "./NotificationsNone.vue?vue&type=script&lang=js&"
export * from "./NotificationsNone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports